import GroomerListComponent from "./GroomerListComponent";
      
const ConfigurationGroomerSetup = () => {
  return (
 <> 
   <GroomerListComponent />
   
    </>
  );
};

export default ConfigurationGroomerSetup;
